let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aR3Ej")).then(() => parcelRequire('kS00n'));